import { useAuthContext } from "../../contexts/AuthContext";
import logger from "../../server/server";

export const isEmpty = (value) => {
    const { user, tenant } = useAuthContext();
    try {
        // Verifica se é um array vazio
        if (Array.isArray(value) && value.length === 0) {
            return true;
        }

        // Verifica se é um objeto vazio
        if (typeof value === 'object' && value !== null && Object.keys(value).length === 0) {
            return true;
        }

        return false;
    } catch (error) {
        console.error('(Homepage page) Error checking if isEmpty:', error);
        logger.error('(Homepage page) User: ' + user?.Username + " Tenant: " + tenant + ', Error checking if isEmpty:', error);
        //reportError(error); // Send error report to backend
    }
};